var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"masonry",style:({'--masonry-cols': _vm.columns, '--masonry-width': _vm.width, '--masonry-gap': _vm.gap})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }